import { inject, Injectable } from '@angular/core';
import { VexLayoutService } from '@vex/services/vex-layout.service';
import { NavigationItem } from './navigation-item.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { LoginService } from '../authentication';
import { AccessValidation } from 'src/app/lib/expo/access.validation';

@Injectable({
  providedIn: 'root'
})
export class NavigationLoaderService {
  private readonly _items: BehaviorSubject<NavigationItem[]> = new BehaviorSubject<NavigationItem[]>([]);
  // Accessvalidation = inject(AccessValidation);
  get items$(): Observable<NavigationItem[]> {
    return this._items.asObservable();
  }
  // private Accessvalidation: AccessValidation,

  userdata: any = '';
  roledata: any = '';
  displayReportChildren: any[] = [];
  registerChildren: any[] = [];
  registersalesChildren: any[] = [];
  stockReportChildren: any[] = [];
  misReportChildren: any[] = [];

  constructor(
    private readonly layoutService: VexLayoutService,
    private loginservice: LoginService
  ) {
    this.loginservice.userData$.subscribe((data) => {
      this.userdata = data;
      this.loadNavigation();
    });
    this.loginservice.roleaccessData$.subscribe((data) => {
      if (data) {
        this.roledata = data;
        this.roledataset();
      }
    });
    const roleaccessdata = this.loginservice.roleaccessget();
    if (roleaccessdata) {
      this.roledata = roleaccessdata;
      this.roledataset();
    }
    // this.Accessvalidation.menuvalidationcheck().forEach((res: any) => {
    //   if (res == true) {
    //   }
    // });
    // this.userdata = this.loginservice.getUserData();
    // this.Accessvalidation.validationcheck()
    // this.loadNavigation();
  }
  roledataset() {
    this.displayReportChildren = [];
    this.registerChildren = [];
    this.registersalesChildren = [];
    this.stockReportChildren = [];
    this.misReportChildren = [];
    this.roledata.forEach((el: any) => {
      if (el.vview) {
        if (el.vch == 'Ledger') {
          this.displayReportChildren.push({
            type: 'link',
            label: 'Ledger',
            route: '/displayreport/ledger',
            icon: 'mat:assignment'
          });
        }
        if (el.vch == 'Daybook') {
          this.displayReportChildren.push({
            type: 'link',
            label: 'Daybook',
            route: '/displayreport/daybook',
            icon: 'mat:assignment'
          });
        }
        if (el.vch == 'Outstanding') {
          this.displayReportChildren.push({
            type: 'link',
            label: 'OutStanding',
            route: '/displayreport/outstanding',
            icon: 'mat:assignment'
          });

          this.displayReportChildren.push({
            type: 'link',
            label: 'Dhirdhar Report',
            route: '/dhirdhar/reportdhirdhar',
            icon: 'mat:assignment'
          });
        }
        if (el.vch == 'Stock Item') {
          this.stockReportChildren.push({
            type: 'link',
            label: 'Stock Item',
            route: '/stockreport/stockitem',
            icon: 'mat:assignment'
          });
        }
        if (el.vch == 'Group Summary') {
          this.stockReportChildren.push({
            type: 'link',
            label: 'Groups Summary',
            route: '/stockreport/groupsummary',
            icon: 'mat:assignment'
          });
        }
        if (el.vch == 'Production Report') {
          this.stockReportChildren.push({
            type: 'link',
            label: 'Production Report',
            route: '/stockreport/productionlist',
            icon: 'mat:assignment'
          });
        }
        if (el.vch == 'Sales Register') {
          this.registersalesChildren.push({
            type: 'link',
            label: 'Sales Register',
            route: '/reportregister/salesregister',
            queryParams: { natvchid: 5 },
            icon: 'mat:assignment'
          });
        }
        if (el.vch == 'Sales Order') {
          this.registersalesChildren.push({
            type: 'link',
            label: 'Sales Order Register',
            route: '/reportregister/salesorderregister',
            icon: 'mat:assignment'
          });
        }
        // if (el.vch == 'Purchase Register') {
        //   this.registerChildren.push({
        //     type: 'link',
        //     label: 'Purchase Register',
        //     route: '/reportregister/purchase',
        //     icon: 'mat:assignment'
        //   });
        // }
        if (el.vch == 'Receipt Register') {
          this.registerChildren.push({
            type: 'link',
            label: 'Receipt Register',
            route: '/reportregister/receipt',
            icon: 'mat:assignment'
          });
        }
        // if (el.vch == 'Expenses Register') {
        //   this.registerChildren.push({
        //     type: 'link',
        //     label: 'Expenses Register',
        //     route: '/reportregister/expenses',
        //     icon: 'mat:assignment'
        //   });
        // }
        if (el.vch == 'Payment Register') {
          this.registerChildren.push({
            type: 'link',
            label: 'Payment Register',
            route: '/reportregister/payment',
            icon: 'mat:assignment'
          });
        }
        if (el.vch == 'Executive Traget Achiver') {
          this.misReportChildren.push({
            type: 'link',
            label: 'Executive Traget Achiver',
            route: '/misreport/exctragetachiv',
            icon: 'mat:assignment'
          });
        }
        if (el.vch == 'In Active Account') {
          this.misReportChildren.push({
            type: 'link',
            label: 'In Active Account',
            route: '/misreport/inactiveacc',
            icon: 'mat:assignment'
          });
        }
      }
    });

    if (this.registersalesChildren.length > 0) {
      this.registerChildren.push({
        type: 'dropdown',
        label: 'Sales',
        icon: 'mat:assignment',
        children: this.registersalesChildren
      });
    }
    this.loadNavigation();
  }
  loadNavigation(): void {
    this._items.next([
      {
        type: 'link',
        label: 'Dashboards',
        route: '/',
        icon: 'mat:dashboard'
        // children: [
        // {
        //   type: 'link',
        //   label: 'Analytics',
        //   route: '/',
        //   icon: 'mat:insights',
        //   routerLinkActiveOptions: { exact: true }
        // }
        // ]
      },
      {
        type: 'subheading',
        label: 'Transaction',
        children: [
          {
            type: 'link',
            label: 'Dhirdhar',
            route: '/dhirdhar/dhirdhar',
            icon: 'mat:assignment'
          },
          {
            type: 'link',
            label: 'Dhirdhar Receipt',
            route: '/dhirdhar/searchdhirdhar',
            icon: 'mat:assignment'
          },
          {
            type: 'link',
            label: 'Sales Order',
            route: '/transaction/salesorder',
            icon: 'mat:assignment'
          },
          {
            type: 'link',
            label: 'Sales',
            route: '/transaction/sales',
            icon: 'mat:assignment'
          },
          {
            type: 'link',
            label: 'Sales Challan',
            route: '/transaction/saleschalan',
            icon: 'mat:assignment'
          },
          {
            type: 'link',
            label: 'Credit Note',
            route: '/transaction/creditnot',
            icon: 'mat:assignment'
          },
          {
            type: 'link',
            label: 'Quotation',
            route: '/transaction/quotation',
            icon: 'mat:assignment'
          },
          {
            type: 'link',
            label: 'Voucher',
            route: '/transaction/voucher',
            icon: 'mat:assignment'
          },
          {
            type: 'link',
            label: 'Production',
            route: '/transaction/production',
            icon: 'mat:assignment'
          },
          {
            type: 'link',
            label: 'Purchase',
            route: '/transaction/purchase',
            icon: 'mat:assignment'
          },
          {
            type: 'dropdown',
            label: 'Inventory',
            icon: 'mat:assignment',
            children: [
              {
                type: 'link',
                label: 'Stock Journal',
                route: '/transaction/inventory/stockjournal'
              }
            ]
          },
          {
            type: 'dropdown',
            label: 'Marketing',
            icon: 'mat:assignment',
            children: [
              {
                type: 'link',
                label: 'Executive Target',
                route: '/transaction/exctargetent'
              }
            ]
          }
        ]
      },
      {
        type: 'subheading',
        label: 'Display Report',
        children: this.displayReportChildren
      },
      {
        type: 'subheading',
        label: 'Register',
        children: this.registerChildren
      },
      {
        type: 'subheading',
        label: 'Stock Report',
        children: this.stockReportChildren
      },

      {
        type: 'subheading',
        label: 'Master',
        children: [
          {
            type: 'dropdown',
            label: 'Account',
            icon: 'mat:assignment',
            children: [
              {
                type: 'link',
                label: 'Account',
                route: '/Master/account/acc'
              },
              {
                type: 'link',
                label: 'Account Dhirdhar',
                route: '/Master/account/accmsdhirdhar'
              },
              {
                type: 'link',
                label: 'Account Group',
                route: '/Master/account/accgrp'
              },
              {
                type: 'link',
                label: 'Branch',
                route: '/Master/account/branch'
              },
              {
                type: 'link',
                label: 'Country',
                route: '/Master/account/country'
              },
              {
                type: 'link',
                label: 'State',
                route: '/Master/account/state'
              },
              {
                type: 'link',
                label: 'Zone',
                route: '/Master/account/zone'
              },
              {
                type: 'link',
                label: 'Executive',
                route: '/Master/account/executive'
              },
              {
                type: 'link',
                label: 'Transport',
                route: '/Master/account/transport'
              }
            ]
          },
          {
            type: 'dropdown',
            label: 'Inventory',
            icon: 'mat:assignment',
            children: [
              {
                type: 'link',
                label: 'Product',
                route: '/Master/inventory/product'
              },
              {
                type: 'link',
                label: 'Product Group',
                route: '/Master/inventory/prdgroup'
              },
              {
                type: 'link',
                label: 'Size',
                route: '/Master/inventory/size'
              },
              {
                type: 'link',
                label: 'Series',
                route: '/Master/inventory/series'
              },
              {
                type: 'link',
                label: 'Grade',
                route: '/Master/inventory/grade'
              },
              {
                type: 'link',
                label: 'Unit',
                route: '/Master/inventory/unit'
              },
              {
                type: 'link',
                label: 'Godown',
                route: '/Master/inventory/godown'
              },
              {
                type: 'link',
                label: 'Category',
                route: '/Master/inventory/category'
              },
              {
                type: 'link',
                label: 'Project',
                route: '/Master/inventory/project'
              }
            ]
          }
        ]
      },

      {
        type: 'subheading',
        label: 'M.I.S Report',
        children: this.misReportChildren
      },

      {
        type: 'subheading',
        label: 'Utilites',
        children: [
          {
            type: 'link',
            label: 'Users Manage',
            route: '/webuser/usermanage',
            icon: 'mat:assignment'
          },
          {
            type: 'link',
            label: 'Users Access',
            route: '/webuser/useraccess',
            icon: 'mat:assignment'
          }
        ]
      },
      {
        type: 'subheading',
        label: 'Configuration',
        children: [
          {
            type: 'link',
            label: 'Configuration',
            route: '/configuration',
            icon: 'mat:assignment'
          }
        ]
      }
    ]);
  }
}

//  this.roledata.forEach((el: any) => {
//           if (!el.vview) return;

//           switch (el.vch) {
//             case 'Ledger':
//               this.displayReportChildren.push({
//                 type: 'link',
//                 label: 'Ledger',
//                 route: '/displayreport/ledger',
//                 icon: 'mat:assignment'
//               });
//               break;
//             case 'Daybook':
//               this.displayReportChildren.push({
//                 type: 'link',
//                 label: 'Daybook',
//                 route: '/displayreport/daybook',
//                 icon: 'mat:assignment'
//               });
//               break;
//             case 'Outstanding':
//               this.displayReportChildren.push({
//                 type: 'link',
//                 label: 'OutStanding',
//                 route: '/displayreport/outstanding',
//                 icon: 'mat:assignment'
//               });
//               break;
//             case 'Stock Item':

//               break;
//             case 'Group Summary':

//               break;
//             case 'Sales Register':

//               break;
//             case 'Sales Order':

//               break;
//             case 'Purchase Register':

//               break;
//             case 'Receipt Register':

//               break;
//             case 'Expenses Register':

//               break;
//             case 'Payment Register':

//               break;
//             case 'Executive Traget Achiver':

//               break;
//           }

//           this.displayReportChildren.push({
//             type: 'link',
//             label: 'Daywise Outstanding',
//             route: '/coming-soon',
//             icon: 'mat:assignment'
//           });
//           this.loadNavigation();
//         });

// {
//   type: 'link',
//   label: 'Grade Stock',
//   route: '/stockreport/gradestock',
//   icon: 'mat:assignment'
// },
// {
//   type: 'dropdown',
//   label: 'Inventory Report',
//   icon: 'mat:assignment',
//   children: [
//     {
//       type: 'link',
//       label: 'Sales Summary',
//       route: '/stockreport/gradestock',
//       queryParams: { rpttype: 'sales' }
//     },
//     {
//       type: 'link',
//       label: 'Production Summary',
//       route: '/stockreport/gradestock',
//       queryParams: { rpttype: 'production' }
//     },
//     {
//       type: 'link',
//       label: 'Sales Ord. Summary',
//       route: '/stockreport/gradestock',
//       queryParams: { rpttype: 'salesorder' }
//     },
//     {
//       type: 'link',
//       label: 'Purchase Summary',
//       route: '/stockreport/gradestock',
//       queryParams: { rpttype: 'purchase' }
//     },
//     {
//       type: 'link',
//       label: 'Stock Journal Summary',
//       route: '/stockreport/gradestock',
//       queryParams: { rpttype: 'stockjournal' }
//     }
//   ]
// }

// {
//   type: 'subheading',
//   label: 'Apps',
//   children: [
//     {
//       type: 'link',
//       label: 'All-In-One Table',
//       route: '/apps/aio-table',
//       icon: 'mat:assignment'
//     },
//     {
//       type: 'dropdown',
//       label: 'Help Center',
//       icon: 'mat:contact_support',
//       children: [
//         {
//           type: 'link',
//           label: 'Getting Started',
//           route: '/apps/help-center/getting-started'
//         },
//         {
//           type: 'link',
//           label: 'Pricing & Plans',
//           route: '/apps/help-center/pricing'
//         },
//         {
//           type: 'link',
//           label: 'FAQ',
//           route: '/apps/help-center/faq'
//         },
//         {
//           type: 'link',
//           label: 'Guides',
//           route: '/apps/help-center/guides'
//         }
//       ]
//     },
//     {
//       type: 'link',
//       label: 'Calendar',
//       route: '/apps/calendar',
//       icon: 'mat:date_range',
//       badge: {
//         value: '12',
//         bgClass: 'bg-purple-600',
//         textClass: 'text-white'
//       }
//     },
//     {
//       type: 'link',
//       label: 'Chat',
//       route: '/apps/chat',
//       icon: 'mat:chat',
//       badge: {
//         value: '16',
//         bgClass: 'bg-cyan-600',
//         textClass: 'text-white'
//       }
//     },
//     {
//       type: 'link',
//       label: 'Mailbox',
//       route: '/apps/mail',
//       icon: 'mat:mail'
//     },
//     {
//       type: 'dropdown',
//       label: 'Social',
//       icon: 'mat:person_outline',
//       children: [
//         {
//           type: 'link',
//           label: 'Profile',
//           route: '/apps/social',
//           routerLinkActiveOptions: { exact: true }
//         },
//         {
//           type: 'link',
//           label: 'Timeline',
//           route: '/apps/social/timeline'
//         }
//       ]
//     },
//     {
//       type: 'link',
//       label: 'WYSIWYG Editor',
//       route: '/apps/editor',
//       icon: 'mat:chrome_reader_mode'
//     },
//     {
//       type: 'dropdown',
//       label: 'Contacts',
//       icon: 'mat:contacts',
//       children: [
//         {
//           type: 'link',
//           label: 'List - Grid',
//           route: '/apps/contacts/grid'
//         },
//         {
//           type: 'link',
//           label: 'List - Table',
//           route: '/apps/contacts/table'
//         }
//       ]
//     },
//     {
//       type: 'link',
//       label: 'Scrumboard',
//       route: '/apps/scrumboard',
//       icon: 'mat:assessment',
//       badge: {
//         value: 'NEW',
//         bgClass: 'bg-primary-600',
//         textClass: 'text-on-primary-600'
//       }
//     }
//   ]
// },
// {
//   type: 'subheading',
//   label: 'Pages',
//   children: [
//     {
//       type: 'dropdown',
//       label: 'Authentication',
//       icon: 'mat:lock',
//       children: [
//         {
//           type: 'link',
//           label: 'Login',
//           route: '/login'
//         },
//         {
//           type: 'link',
//           label: 'Register',
//           route: '/register'
//         },
//         {
//           type: 'link',
//           label: 'Forgot Password',
//           route: '/forgot-password'
//         }
//       ]
//     },
//     {
//       type: 'link',
//       label: 'Coming Soon',
//       icon: 'mat:watch_later',
//       route: '/coming-soon'
//     },
//     {
//       type: 'dropdown',
//       label: 'Errors',
//       icon: 'mat:error',
//       badge: {
//         value: '4',
//         bgClass: 'bg-green-600',
//         textClass: 'text-white'
//       },
//       children: [
//         {
//           type: 'link',
//           label: '404',
//           route: '/pages/error-404'
//         },
//         {
//           type: 'link',
//           label: '500',
//           route: '/pages/error-500'
//         }
//       ]
//     },
//     {
//       type: 'link',
//       label: 'Pricing',
//       icon: 'mat:attach_money',
//       route: '/pages/pricing'
//     },
//     {
//       type: 'link',
//       label: 'Invoice',
//       icon: 'mat:receipt',
//       route: '/pages/invoice'
//     },
//     {
//       type: 'link',
//       label: 'FAQ',
//       icon: 'mat:help',
//       route: '/pages/faq'
//     },
//     {
//       type: 'link',
//       label: 'Guides',
//       icon: 'mat:book',
//       route: '/pages/guides',
//       badge: {
//         value: '18',
//         bgClass: 'bg-teal-600',
//         textClass: 'text-white'
//       }
//     }
//   ]
// },
// {
//   type: 'subheading',
//   label: 'UI Elements',
//   children: [
//     {
//       type: 'dropdown',
//       label: 'Components',
//       icon: 'mat:bubble_chart',
//       children: [
//         {
//           type: 'link',
//           label: 'Overview',
//           route: '/ui/components/overview'
//         },
//         {
//           type: 'link',
//           label: 'Autocomplete',
//           route: '/ui/components/autocomplete'
//         },
//         {
//           type: 'link',
//           label: 'Buttons',
//           route: '/ui/components/buttons'
//         },
//         {
//           type: 'link',
//           label: 'Button Group',
//           route: '/ui/components/button-group'
//         },
//         {
//           type: 'link',
//           label: 'Cards',
//           route: '/ui/components/cards'
//         },
//         {
//           type: 'link',
//           label: 'Checkbox',
//           route: '/ui/components/checkbox'
//         },
//         {
//           type: 'link',
//           label: 'Dialogs',
//           route: '/ui/components/dialogs'
//         },
//         {
//           type: 'link',
//           label: 'Grid List',
//           route: '/ui/components/grid-list'
//         },
//         {
//           type: 'link',
//           label: 'Input',
//           route: '/ui/components/input'
//         },
//         {
//           type: 'link',
//           label: 'Lists',
//           route: '/ui/components/lists'
//         },
//         {
//           type: 'link',
//           label: 'Menu',
//           route: '/ui/components/menu'
//         },
//         {
//           type: 'link',
//           label: 'Progress',
//           route: '/ui/components/progress'
//         },
//         {
//           type: 'link',
//           label: 'Progress Spinner',
//           route: '/ui/components/progress-spinner'
//         },
//         {
//           type: 'link',
//           label: 'Radio',
//           route: '/ui/components/radio'
//         },
//         {
//           type: 'link',
//           label: 'Slide Toggle',
//           route: '/ui/components/slide-toggle'
//         },
//         {
//           type: 'link',
//           label: 'Slider',
//           route: '/ui/components/slider'
//         },
//         {
//           type: 'link',
//           label: 'Snack Bar',
//           route: '/ui/components/snack-bar'
//         },
//         {
//           type: 'link',
//           label: 'Tooltip',
//           route: '/ui/components/tooltip'
//         }
//       ]
//     },
//     {
//       type: 'dropdown',
//       label: 'Forms',
//       icon: 'mat:format_color_text',
//       children: [
//         {
//           type: 'link',
//           label: 'Form Elements',
//           route: '/ui/forms/form-elements'
//         },
//         {
//           type: 'link',
//           label: 'Form Wizard',
//           route: '/ui/forms/form-wizard'
//         }
//       ]
//     },
//     {
//       type: 'dropdown',
//       label: 'Icons',
//       icon: 'mat:star',
//       children: [
//         {
//           type: 'link',
//           label: 'Material Icons',
//           route: '/ui/icons/ic'
//         },
//         {
//           type: 'link',
//           label: 'FontAwesome Icons',
//           route: '/ui/icons/fa'
//         }
//       ]
//     },
//     {
//       type: 'dropdown',
//       label: 'Page Layouts',
//       icon: 'mat:view_compact',
//       children: [
//         {
//           type: 'dropdown',
//           label: 'Card',
//           children: [
//             {
//               type: 'link',
//               label: 'Default',
//               route: '/ui/page-layouts/card',
//               routerLinkActiveOptions: { exact: true }
//             },
//             {
//               type: 'link',
//               label: 'Tabbed',
//               route: '/ui/page-layouts/card/tabbed'
//             },
//             {
//               type: 'link',
//               label: 'Large Header',
//               route: '/ui/page-layouts/card/large-header',
//               routerLinkActiveOptions: { exact: true }
//             },
//             {
//               type: 'link',
//               label: 'Tabbed & Large Header',
//               route: '/ui/page-layouts/card/large-header/tabbed'
//             }
//           ]
//         },
//         {
//           type: 'dropdown',
//           label: 'Simple',
//           children: [
//             {
//               type: 'link',
//               label: 'Default',
//               route: '/ui/page-layouts/simple',
//               routerLinkActiveOptions: { exact: true }
//             },
//             {
//               type: 'link',
//               label: 'Tabbed',
//               route: '/ui/page-layouts/simple/tabbed'
//             },
//             {
//               type: 'link',
//               label: 'Large Header',
//               route: '/ui/page-layouts/simple/large-header',
//               routerLinkActiveOptions: { exact: true }
//             },
//             {
//               type: 'link',
//               label: 'Tabbed & Large Header',
//               route: '/ui/page-layouts/simple/large-header/tabbed'
//             }
//           ]
//         },
//         {
//           type: 'link',
//           label: 'Blank',
//           icon: 'mat:picture_in_picture',
//           route: '/ui/page-layouts/blank'
//         }
//       ]
//     }
//   ]
// },
// {
//   type: 'subheading',
//   label: 'Documentation',
//   children: [
//     {
//       type: 'link',
//       label: 'Changelog',
//       route: '/documentation/changelog',
//       icon: 'mat:update'
//     },
//     {
//       type: 'dropdown',
//       label: 'Getting Started',
//       icon: 'mat:book',
//       children: [
//         {
//           type: 'link',
//           label: 'Introduction',
//           route: '/documentation/introduction',
//           fragment: 'introduction',
//           routerLinkActiveOptions: { exact: true }
//         },
//         {
//           type: 'link',
//           label: 'Folder Structure',
//           route: '/documentation/folder-structure',
//           fragment: 'folder-structure',
//           routerLinkActiveOptions: { exact: true }
//         },
//         {
//           type: 'link',
//           label: 'Installation',
//           route: '/documentation/installation',
//           fragment: 'installation',
//           routerLinkActiveOptions: { exact: true }
//         },
//         {
//           type: 'link',
//           label: 'Development Server',
//           route: '/documentation/start-development-server',
//           fragment: 'start-development-server',
//           routerLinkActiveOptions: { exact: true }
//         },
//         {
//           type: 'link',
//           label: 'Build for Production',
//           route: '/documentation/build-for-production',
//           fragment: 'build-for-production',
//           routerLinkActiveOptions: { exact: true }
//         }
//       ]
//     },
//     {
//       type: 'dropdown',
//       label: 'Customization',
//       icon: 'mat:book',
//       children: [
//         {
//           type: 'link',
//           label: 'Configuration',
//           route: '/documentation/configuration',
//           fragment: 'configuration',
//           routerLinkActiveOptions: { exact: true }
//         },
//         {
//           type: 'link',
//           label: 'Changing Styling',
//           route: '/documentation/changing-styling-and-css-variables',
//           fragment: 'changing-styling-and-css-variables',
//           routerLinkActiveOptions: { exact: true }
//         },
//         {
//           type: 'link',
//           label: 'Using Custom Colors',
//           route:
//             '/documentation/using-custom-colors-for-the-primarysecondarywarn-palettes',
//           fragment:
//             'using-custom-colors-for-the-primarysecondarywarn-palettes',
//           routerLinkActiveOptions: { exact: true }
//         },
//         {
//           type: 'link',
//           label: 'Adding Menu Items',
//           route: '/documentation/adding-menu-items',
//           fragment: 'adding-menu-items',
//           routerLinkActiveOptions: { exact: true }
//         }
//       ]
//     },
//     {
//       type: 'link',
//       label: 'Further Help',
//       icon: 'mat:book',
//       route: '/documentation/further-help',
//       fragment: 'further-help',
//       routerLinkActiveOptions: { exact: true }
//     }
//   ]
// },
// {
//   type: 'subheading',
//   label: 'Customize',
//   children: []
// },
// {
//   type: 'link',
//   label: 'Configuration',
//   route: () => this.layoutService.openConfigpanel(),
//   icon: 'mat:settings'
// }
